import { Button } from '@amzn/awsui-components-core';
import {
  CodeLink,
  CodeRepoReviewStatus,
  RepoType,
} from '@amzn/awscat-pattern-library-service-model';
import React, { useState } from 'react';
import CodeRepoModal from './CodeRepoModal';
import { CodeRepoFormCtx, CodeRepoFormCtxData } from './form/CodeRepoFormContext';
import constants from '../../../../common/constants';
import { CodeRepoFormData } from './form/CodeRepoFormData';

interface Props {
  disabled: boolean;
  addRepoToContent: (repoData: CodeLink) => void;
  allowedRepoType: RepoType;
}

const AddCodeRepoModalButton = (props: Props) => {
  const { allowedRepoType } = props;
  const newRepoDefaultValues = {
    repoType: allowedRepoType,
    securityReviewStatus: CodeRepoReviewStatus.NotStarted,
    openSourceReviewStatus: CodeRepoReviewStatus.NotStarted,
  };
  const [newRepoData, setNewRepoData] = useState<CodeRepoFormData>(newRepoDefaultValues);
  const [invalidFormFields, setInvalidFormFields] = useState(new Set<string>());
  const [showValidationErrors, setShowValidationErrors] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => setIsModalVisible(true);
  const hideModal = () => {
    setIsModalVisible(false);
    setNewRepoData(newRepoDefaultValues);
    setInvalidFormFields(new Set<string>());
    setShowValidationErrors(false);
  };

  const handleInputValidation = (fieldId: string, invalid: boolean) => {
    if (invalid) {
      invalidFormFields.add(fieldId);
    } else {
      invalidFormFields.delete(fieldId);
    }
    setInvalidFormFields(invalidFormFields);
  };

  const contextData: CodeRepoFormCtxData = {
    repoData: newRepoData,
    setRepoData: setNewRepoData,
    addRepoToContent: props.addRepoToContent,
    invalidFormFields,
    onInputValidation: handleInputValidation,
    showValidationErrors,
    setShowValidationErrors,
  };

  return (
    <CodeRepoFormCtx.Provider value={contextData}>
      <Button iconName="add-plus" onClick={showModal} disabled={props.disabled}>
        {constants.CODE_REPO_ADD_BUTTON_TEXT}
      </Button>
      <CodeRepoModal visible={isModalVisible} onDismiss={hideModal} />
    </CodeRepoFormCtx.Provider>
  );
};

export default AddCodeRepoModalButton;
